/* Generic one-tap add-to-cart button wrapper: <beme-quick-add data-variant="...">
   Adds one unit via /cart/add.js and refreshes the theme's cart drawer. */

(() => {
  if (window.BemeQuickAddLoaded) return;
  window.BemeQuickAddLoaded = true;

  class BemeQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.btn = this.querySelector('button');
      this.status = this.querySelector('[data-beme-quick-add-status]');
      this.productName = this.getAttribute('data-product') || 'Item';
      if (this.btn) {
        this.btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.add();
        });
      }
    }

    async add() {
      const id = Number.parseInt(this.getAttribute('data-variant'), 10);
      if (!Number.isFinite(id) || !this.btn || this.btn.disabled) return;

      const previousText = this.btn.textContent.trim();
      const previousLabel = this.btn.getAttribute('aria-label');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      this.btn.disabled = true;
      this.btn.setAttribute('aria-busy', 'true');
      this.btn.textContent = 'Adding…';
      if (this.status) this.status.textContent = `Adding ${this.productName} to your cart.`;

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error('Unable to add item');

        this.btn.textContent = 'Added ✓';
        if (this.status) this.status.textContent = `${this.productName} was added to your cart.`;
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      } catch (error) {
        this.btn.textContent = 'Try again';
        if (this.status) this.status.textContent = `${this.productName} could not be added. Please try again.`;
      } finally {
        this.btn.removeAttribute('aria-busy');
        window.setTimeout(() => {
          this.btn.disabled = false;
          this.btn.textContent = previousText;
          if (previousLabel) this.btn.setAttribute('aria-label', previousLabel);
        }, 1600);
      }
    }
  }

  customElements.define('beme-quick-add', BemeQuickAdd);
})();
